import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import RoundImage from './Image/RoundImage';

import { width } from '../utils/size';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;

    input:focus {
        outline: none;
        border: solid 1px #008eff;
    }
`;

const Wrapper = styled.div`
    height: auto;
    border-radius: 2px;
    border: solid 1px ${props => (props.touched && props.error ? '#ff245e' : '#f1f1ee')};
    font-family: Averta;
    font-size: 0.875em;
    line-height: 1.43;
    padding: 0.571em 0.571em 0 0.571em;
    min-height: 42px;
    color: ${props =>
        props.touched && props.error
            ? '#ff245e'
            : props.inputColor != null
            ? props.inputColor
            : '#333'};
    -webkit-appearance: none;

    &::placeholder {
        color: #a59f9f;
    }
`;

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Error = styled.div`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-align: right;
    color: #ff245e;
    text-transform: uppercase;
`;

const Label = styled.label`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.5em;
`;

const RepContainer = styled.div`
    text-align: center;
    float: left;
    display: flex;
    border-radius: 12px;
    background-color: #f1f1ee;
    margin: 0 10px 0.571em 0;
    position: relative;
    padding-right: ${props => (props.repsLength > 1 ? '20px' : '0')};

    &:last-child {
        margin-right: 0;
    }

    &:hover {
        background: #dadad9;

        .closeButton {
            color: #000;
        }
    }

    &.styled {
        margin-right: 0;
        padding-right: 0;
        white-space: nowrap;
        cursor: pointer;

        &:last-child {
            margin-bottom: 0;
        }
    }

    div {
        margin: 0 auto;
    }
`;

const RepTitle = styled.h2`
    font-family: Averta;
    font-size: 12px;
    font-weight: normal;
    line-height: 24px;
    padding: 0 8px;
    margin: 0;
    color: #000;
`;

const CloseButton = styled.div`
    width: 14px;
    height: 26px;
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 20px;
    line-height: 1.08;
    text-align: left;
    color: #bbb;
    cursor: pointer;
    position: absolute;
    right: 6px;
    top: 1px;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    &:hover,
    &:focus {
        outline: none;
    }
`;

const AddButtonWrapper = styled.div`
    float: left;
    position: relative;
`;

const AddButton = styled.div`
    width: 26px;
    height: 26px;
    font-family: Averta;
    font-size: 20px;
    line-height: 24px;
    color: #bbb;
    cursor: pointer;
    text-align: center;
    border-radius: 100%;
    background: #f1f1ee;
    transform: ${props => (props.representativesVisibility ? 'rotate(45deg)' : '')};
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    &:hover,
    &:focus {
        outline: none;
    }

    &:hover {
        background: #dadad9;
        color: #000;
    }

    &.visible {
        + div {
            display: block;
        }
    }

    &.to-right {
        + div {
            left: auto;
            right: 0;
        }
    }
`;

const RepWrapper = styled.div`
    position: absolute;
    z-index: 1;
    left: 0;
    top: 100%;
    padding: 15px;
    margin: 4px 0 0 0;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(42, 42, 42, 0.1);
    background-color: #ffffff;
    border: solid 1px #f1f1ee;
    display: none;
`;

const ImageContainer = styled.div`
    display: flex;
`;

class InputGroupCustom extends React.Component {
    constructor(props) {
        super(props);
        this.focusTextInput = this.focusTextInput.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.setCorrectHeight);
        this.setCorrectHeight();

        if (this.props.autoFocus) {
            this.focusTextInput();
        }
    }

    setCorrectHeight() {
        if (
            document.getElementById('recepientsWrapper') &&
            document.getElementById('textarea') &&
            document.getElementById('labelResponse')
        ) {
            setTimeout(() => {
                let val1;
                let val2;
                if (width() >= 480) {
                    val1 = 128;
                    val2 = 200;
                } else {
                    val1 = 298;
                    val2 = 370;
                }
                const recepientsWrapperHeight = document.getElementById(
                    'recepientsWrapper'
                ).clientHeight;
                const labelTextarea = document.getElementById('textarea');
                const labelResponse = document.getElementById('labelResponse');
                labelTextarea.style.height = val1 - recepientsWrapperHeight + 'px';
                labelResponse.style.bottom = val2 - recepientsWrapperHeight + 'px';
            });
        }
    }

    focusTextInput() {
        // timeout is not working on iOS Safari
        // if (this.props.autoFocusTimeout) {
        //   setTimeout(() => {
        //     findDOMNode(this.textInput).focus()
        //   }, this.props.autoFocusTimeout)
        // } else {
        //   findDOMNode(this.textInput).focus()
        // }

        this.textInput.focus();
    }

    render() {
        return (
            <Container id="recepientsWrapper">
                <LabelContainer>
                    <Label htmlFor="">{this.props.label}</Label>
                    {this.props.meta.touched && this.props.meta.error && (
                        <Error>{this.props.meta.error}</Error>
                    )}
                </LabelContainer>
                <Wrapper>
                    {this.props.representatives.map(a => (
                        <RepContainer
                            key={a.index}
                            repsLength={this.props.representatives.length}
                        >
                            <ImageContainer>
                                <RoundImage src={a.photoUrl} size="24px" />
                            </ImageContainer>
                            <RepTitle>{a.shortName}</RepTitle>
                            {this.props.representatives.length > 1 && (
                                <CloseButton
                                    onClick={() => this.props.onDeleteClick(a.fullName)}
                                    className="closeButton"
                                >
                                    +
                                </CloseButton>
                            )}
                        </RepContainer>
                    ))}
                    {this.props.hiddenRepresentatives.length > 0 && (
                        <AddButtonWrapper>
                            <AddButton
                                onClick={() => this.props.onShowRepresentatives()}
                                representativesVisibility={
                                    this.props.representativesVisibility
                                }
                                id="addButton"
                            >
                                +
                            </AddButton>
                            {this.props.representativesVisibility && (
                                <RepWrapper>
                                    {this.props.hiddenRepresentatives.map(a => (
                                        <RepContainer
                                            key={a.index}
                                            className="styled"
                                            onClick={() =>
                                                this.props.onAddClick(a.fullName)
                                            }
                                        >
                                            <ImageContainer>
                                                <RoundImage
                                                    src={a.photoUrl}
                                                    size="24px"
                                                />
                                            </ImageContainer>
                                            <RepTitle>{a.shortName}</RepTitle>
                                        </RepContainer>
                                    ))}
                                </RepWrapper>
                            )}
                        </AddButtonWrapper>
                    )}
                </Wrapper>
            </Container>
        );
    }
}

InputGroupCustom.propTypes = {
    label: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    autoFocus: PropTypes.bool,
    representatives: PropTypes.array,
    hiddenRepresentatives: PropTypes.array,
    onDeleteClick: PropTypes.func,
    onAddClick: PropTypes.func,
    onShowRepresentatives: PropTypes.func,
    representativesVisibility: PropTypes.bool
};

export default InputGroupCustom;



// WEBPACK FOOTER //
// ./src/components/InputGroupCustom.jsx